export const searchPhrasesLowValueThreshold = 15;
export const DASHBOARD_TOP_SEARCH_PHRASES_COUNT_TO_SHOW = 10;
